.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(180deg, color-mix(in srgb, var(--static-background-weak) 0%, transparent) 0%, var(--static-background-weak) 0%, color-mix(in srgb, var(--static-background-strong) 0%, transparent) 68.15%, var(--static-background-weak) 100%);
  backdrop-filter: blur(12px);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  z-index: 9;
  padding: 2.5rem 2.5rem;
}

.overlayContent {
  width: 100%;
  height: 100%;
  position: relative;
}

.wrapper {
  width: 100%;
  padding: 2rem;
  border: 1px solid var(--static-divider-standard);
  border-radius: 12px;
  background: var(--static-background-strong);
}

.header {
  justify-content: flex-start;
}

.analyticsTitle {
  font-size: 32px;
  font-weight: 600;
  color: var(--static-text-strong);
  margin: 0;
}

.content {
  width: 100%;
}

.lockContainer {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.iconContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  background: var(--sentiment-background-notice);
  border-radius: 50%;
  flex-shrink: 0;
}

.iconContainer svg {
  width: 61px;
  height: 61px;
}

.title {
  font-size: 28px;
  font-weight: 600;
  color: var(--static-text-strong);
  margin: 0;
  text-align: left;
}

.description {
  font-size: 16px;
  color: var(--static-text-standard);
  line-height: 1.5;
  margin: 0;
  text-align: left;
}

